const projectsText = `Here are a few projects that I recently worked on!`;

export default projectsText;
